import $ from 'jquery';
import 'fullpage.js';
import {Lethargy} from 'lethargy';
import {getSiblings} from './utils';
import { debounce } from 'throttle-debounce';

const lethargy = new Lethargy(20, 100, 0.05);

const defaultSettings = {
  easing: 'easeInOutCubic',
  easingcss3: 'ease',
  fitToSection: true,
  fitToSectionDelay: 1000,
  css3: true,
  scrollingSpeed: 700,
  bullets: true
};

export default class FullPage {
  constructor(options = {}, onRenderCallbacks = [], onLeaveCallbacks = []) {
    this.page = document.querySelector(`.page`);
    this.slider = $(`#fullpage`);
    this.screens = [...this.page.querySelectorAll(`.section.screen`)];
    this.initialScreen = this.screens.find(screen => `#` + screen.dataset.anchor === window.location.hash);
    this.onLeaveCallbacks = new Set(onLeaveCallbacks);
    this.onRenderCallbacks = new Set(onRenderCallbacks);
    this.options = {
      ...defaultSettings,
      ...options,
      afterRender: () => {
        const initialScreenName = this.initialScreen ? this.initialScreen.dataset.anchor : `intro`;
        const initialScreenIndex = this.screens.findIndex(screen => screen.dataset.anchor === initialScreenName) + 1;

        for (let cb of this.onRenderCallbacks) {
          cb(initialScreenIndex, initialScreenName);
        }
      },
      onLeave: (index, nextIndex) => {
        for (let cb of this.onLeaveCallbacks) {
          cb(nextIndex);
        }
      }
    }
  }

  init() {
    if (this.options.bullets) {
      this._initBullets();
    }

    this.slider.fullpage(this.options);
    $(window).bind('mousewheel DOMMouseScroll wheel MozMousePixelScroll', debounce(1700, function (e) {
      e.preventDefault();
      e.stopPropagation();
      $.fn.fullpage.setAllowScrolling(false);
      if (lethargy.check(e) !== false && !$(`body`).hasClass('page--opened-modal')) {
        $.fn.fullpage.setAllowScrolling(true);
      }
    }));
  }

  static destroy() {
    $.fn.fullpage.destroy();
  }

  _initBullets() {
    this._createBullets();

    const bullets = [...this.page.querySelectorAll(`.bullets__item`)];
    const setInitialBullet = screenIndex => this._toggleBulletsState(bullets[screenIndex - 1]);
    const toggleNextBullet = (nextIndex) => this._toggleBulletsState(bullets[nextIndex - 1]);

    this.onRenderCallbacks.add(setInitialBullet);
    this.onLeaveCallbacks.add(toggleNextBullet);

    bullets.forEach(bullet => bullet.addEventListener(`click`, e => {
      this._toggleBulletsState(e.currentTarget);
    }));
  }

  _createBullets() {
    const socials = this.page.querySelector(`.socials`);
    const bulletsContainer = document.createElement(`ul`);

    bulletsContainer.className = `side-panel side-panel--right bullets`;
    this.page.insertBefore(bulletsContainer, socials);

    this.screens.forEach((screen, index) => {
      const bullet = document.createElement(`li`);

      bullet.className = `bullets__item`;
      bullet.dataset.href = screen.dataset.anchor;
      bullet.innerHTML = `<a class="bullets__link" href=#${screen.dataset.anchor}>Экран ${index + 1}</a>`;
      bulletsContainer.appendChild(bullet);
    });
  }

  _toggleBulletsState = bullet => {
    const siblings = getSiblings(bullet);

    bullet.classList.add(`bullets__item--active`);
    siblings.forEach(sibling => sibling.classList.remove(`bullets__item--active`));
  }
}
